export default "__VITE_ASSET__$m3cIh2q__"